module.exports = __webpack_public_path__ + "img/blog-article-background-1.1642cbec.png";